// 引入依赖
import Vue from 'vue'
import VueRouter from 'vue-router'

// 安装路由
Vue.use(VueRouter)

// 配置路由规则
const routes = [
  {
    path: '/',
    component: () => import('@/views/home-page.vue')
  },
  {
    path: '/database',
    component: () => import('@/views/Database/index.vue')
  }
]

// 创建路由实例
const router = new VueRouter({
  routes
})

// 导出路由
export default router